<template>
  <ScrollArea class="h-116.5 w-full">
    <div class="relative w-full h-full">
      <Button
        color="normal"
        shape="circle"
        size="icon-md"
        class="absolute right-0 top-0"
        @click="emit('close')"
      >
        <Icon icon="Status-Wireframe-Close" />
      </Button>
      <article class="flex flex-col gap-2" v-html="renderedHtml"></article>
    </div>
  </ScrollArea>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useLocaleStore } from '@/stores'
  import { Button, Icon, ScrollArea } from '@rapoo/element'

  const emit = defineEmits<{
    (e: 'close'): void
  }>()

  const { t } = useLocaleStore()

  const renderedHtml = computed(() => t('home.chinaGameSupportList'))
</script>

<style scoped></style>
